(function () {
  'use strict';
  if (window.roccoMobileTextCollapse) return;
  window.roccoMobileTextCollapse = true;
  var selector = '.image-with-text__content .image-with-text__text.rte, [class*="feature-text-"][class*="feature-element-mobile-"]';
  var mobile = window.matchMedia('(max-width: 749px)');
  var states = new WeakMap();
  var controls = new WeakMap();
  var active = new Set();
  var pending = new Set();
  var sliders = new Set();
  var frame = null;
  var sliderFrame = null;
  var nextId = 0;
  var labels = {
    de: { more: 'Mehr lesen', less: 'Weniger anzeigen' },
    it: { more: 'Leggi di più', less: 'Mostra meno' },
    en: { more: 'Read more', less: 'Show less' }
  };

  function refreshSlider(element) {
    var slider = element.closest('.swiper');
    if (!slider) return;
    sliders.add(slider);
    if (sliderFrame) return;
    sliderFrame = requestAnimationFrame(function () {
      sliderFrame = null;
      sliders.forEach(function (node) {
        var swiper = node.swiper;
        if (swiper && !swiper.destroyed && typeof swiper.updateAutoHeight === 'function') swiper.updateAutoHeight(0);
      });
      sliders.clear();
    });
  }

  function restoreFocus(state) {
    state.tabIndexes.forEach(function (value, node) {
      if (value === null) node.removeAttribute('tabindex');
      else node.setAttribute('tabindex', value);
    });
    state.tabIndexes.clear();
  }
  function updateFocus(state, collapsed) {
    restoreFocus(state);
    if (!collapsed) return;
    var bottom = state.element.getBoundingClientRect().top + 205;
    state.element.querySelectorAll('a[href],button,input,select,textarea,[tabindex]').forEach(function (node) {
      if (node.getBoundingClientRect().bottom <= bottom) return;
      state.tabIndexes.set(node, node.getAttribute('tabindex'));
      node.setAttribute('tabindex', '-1');
    });
  }

  function render(state) {
    var element = state.element;
    if (!element.isConnected) {
      restoreFocus(state);
      state.button.remove();
      resizeObserver.unobserve(element);
      active.delete(state);
      return;
    }
    if (state.button.previousElementSibling !== element) element.insertAdjacentElement('afterend', state.button);
    var naturalHeight = element.scrollHeight;
    var eligible = mobile.matches && element.clientWidth > 0 && naturalHeight > 240;
    var collapsed = eligible && !state.expanded;
    var changed = element.hasAttribute('data-rocco-text-collapsed') !== collapsed || state.button.hidden === eligible;
    if (element.hasAttribute('data-rocco-text-collapsed') !== collapsed) element.toggleAttribute('data-rocco-text-collapsed', collapsed);
    if (state.button.hidden !== !eligible) state.button.hidden = !eligible;
    var language = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    var copy = labels[language] || labels.en;
    var label = state.expanded ? copy.less : copy.more;
    if (state.label.textContent !== label) state.label.textContent = label;
    state.button.setAttribute('aria-expanded', String(eligible ? state.expanded : true));
    updateFocus(state, collapsed);
    var height = element.getBoundingClientRect().height;
    if (changed || state.height !== height) refreshSlider(element);
    state.height = height;
  }

  function schedule(state) {
    pending.add(state);
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      pending.forEach(render);
      pending.clear();
    });
  }
  var resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { var state = states.get(entry.target); if (state) schedule(state); });
  });

  function enhance(element) {
    var state = states.get(element);
    if (state) { schedule(state); return; }
    if (!element.id || element.id.indexOf('RoccoMobileText-') === 0) element.id = 'RoccoMobileText-' + (++nextId);
    element.setAttribute('data-rocco-mobile-text', '');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rocco-text-toggle';
    button.hidden = true;
    button.setAttribute('aria-controls', element.id);
    var label = document.createElement('span');
    button.appendChild(label);
    button.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5 7.5 5 5 5-5"/></svg>');
    state = { element: element, button: button, label: label, expanded: false, height: null, tabIndexes: new Map() };
    states.set(element, state);
    controls.set(button, element);
    active.add(state);
    button.addEventListener('click', function () {
      state.expanded = !state.expanded;
      render(state);
      if (!state.expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    });
    element.insertAdjacentElement('afterend', button);
    resizeObserver.observe(element);
    schedule(state);
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) enhance(root);
    root.querySelectorAll(selector).forEach(enhance);
    // Remove copied/orphaned controls after a slider or theme-editor rerender.
    root.querySelectorAll('.rocco-text-toggle').forEach(function (button) {
      var owner = controls.get(button);
      if (!owner || !owner.isConnected) button.remove();
    });
  }
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(scan);
      var node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      var element = node && node.closest(selector);
      var state = element && states.get(element);
      if (state) schedule(state);
    });
    active.forEach(function (state) { if (!state.element.isConnected) schedule(state); });
  }).observe(document, { childList: true, subtree: true, characterData: true });
  function scheduleAll() { active.forEach(schedule); }
  mobile.addEventListener('change', scheduleAll);
  window.addEventListener('resize', scheduleAll, { passive: true });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleAll);
  scan(document);
})();
